import type { ReactNode } from 'react';

import { TipsShareSheetContainer } from './tips-share-sheet-container';
import { TipsShareSheetOverlayFrame } from './tips-share-sheet-overlay-frame';

type TipsShareSheetShellProps = {
  isOpen: boolean;
  onClose: () => void;
  onCloseComplete: () => void;
  children: ReactNode;
};

export function TipsShareSheetShell({
  isOpen,
  onClose,
  onCloseComplete,
  children,
}: TipsShareSheetShellProps) {
  return (
    <TipsShareSheetOverlayFrame isOpen={isOpen} onClose={onClose}>
      <TipsShareSheetContainer
        isOpen={isOpen}
        onCloseComplete={onCloseComplete}
      >
        {children}
      </TipsShareSheetContainer>
    </TipsShareSheetOverlayFrame>
  );
}
